import { DeleteOutlined, EditOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';
import { Button, message, Modal, Space, Tooltip } from 'antd';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { MISC } from '../../../../constants/define/translation';
import { MESSAGE_ERROR } from '../../../../constants/message';
import {
  ExternalToolRecord,
  postDeleteExternalToolRepository,
} from '../../../../repository/mytm/external-tool/externalToolRepository';
import { btnActive } from '../../../../styles';

interface ActionsColumnProps {
  record: ExternalToolRecord;
  onRefresh: () => void;
  setCurrentRecord: (record: ExternalToolRecord) => void;
  onOpenModal: (isOpen: boolean) => void;
  onSetLoading: (loading: boolean) => void;
}

export default React.memo((props: ActionsColumnProps) => {
  const { t } = useTranslation(MISC);
  const { record, onRefresh, setCurrentRecord, onOpenModal, onSetLoading } = props;

  const handleEdit = useCallback(() => {
    setCurrentRecord(record);
    onOpenModal(true);
  }, [record, setCurrentRecord]);

  const handleDelete = useCallback(async () => {
    Modal.confirm({
      title: t('popup.title'),
      okText: t('popup.okBtn'),
      cancelText: t('popup.cancelBtn'),
      icon: <ExclamationCircleOutlined />,
      content: t('popup.deleteExternal'),
      onOk() {
        onSetLoading(true);
        postDeleteExternalToolRepository({ id: record?.id })
          .then(() => {
            onRefresh();
            onSetLoading(false);
            message.success(t('message.deleteExternalToolSuccess'));
          })
          .catch(error => {
            onSetLoading(false);
            message.error(MESSAGE_ERROR.M02);
          });
      },
    });
  }, [record, onSetLoading, onRefresh]);

  return (
    <StyledContainer>
      <Space size="small">
        <Tooltip title={t('tooltip.edit')}>
          <Button icon={<EditOutlined />} onClick={handleEdit} className="active" />
        </Tooltip>
        <Tooltip title={t('tooltip.delete')}>
          <Button icon={<DeleteOutlined />} onClick={handleDelete} className="delete" />
        </Tooltip>
      </Space>
    </StyledContainer>
  );
});

const StyledContainer = styled.div`
  button.ant-btn {
    background: #eee;
    border-color: #eee;
  }
  ${btnActive}
`;
